import img1 from "../../../assets/delivery.png";
import img2 from "../../../assets/contact.png";

const HeroSection = () => {
  return (
    <div className="px-6 lg:px-16 my-10">
      <div className="lg:grid grid-cols-2 gap-28">
        <div className="max-w-[550px] lg:ml-[82px] lg:py-4">
          <h1 className="text-2xl lg:text-[40px] lg:leading-[54px] my-3 lg:my-5 font-semibold text-primaryBlack;">
            ZAP offers fast and efficient delivery services for packages of all
            sizes
          </h1>
        </div>
        <div className="lg:relative lg:max-w-[600px]">
          <span className="text-paragraph text-[22px] lg:absolute lg:bottom-0 leading-[32.63px]">
            We guarantee lightning-fast and dependable delivery services for
            packages of all shapes and sizes. Experience hassle-free shipping at
            its finest!
          </span>
        </div>
      </div>
      <div className="lg:grid grid-cols-2 gap-10 my-20 max-lg:space-y-6">
        <div>
          <img
            src={img1}
            alt=""
            className="h-[90%] w-full hover:scale-[1.03] duration-700"
          />
        </div>
        <div>
          <img
            src={img2}
            alt=""
            className="lg:h-[90%] hover:scale-[1.03] duration-700"
          />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
